module.exports = __webpack_public_path__ + "static/media/bg_rectangle-light-1.029828b1.jpg";